import React, { useEffect, useState, useRef, useCallback } from 'react';
import { DataService } from '../../../services/data-service';
import { LoaderService } from '../../../services/loader-service';
import { filter, take } from 'rxjs/operators';

const STORAGE_KEY = 'formContextState';

export const FormContext = React.createContext({
  validated: false,
  setValidationStyleOn: () => {},
  formValues: {},
  setFormValues: () => {},
  apiFormInfo: {},
  removeFormValue: () => {},
  clearSavedState: () => {}
});

export const FormContextProvider = (props) => {
  console.log('=== FormContextProvider render ===');
  const [validated, setValidation] = useState(false);
  const [formValues, setValues] = useState({});
  const [apiFormInfo, setFormInfo] = useState({});
  const activeRequestId = useRef(0);

  useEffect(() => {
    console.log('=== FormContextProvider montado, suscribiéndose ===');
    let lastPayloadHash = null; // ✅ ignorar el mismo payload repetido

    const payloadSubscription = DataService.getPayloadToRetrieveFormInfo()
      .pipe(filter(payload => payload !== null))
      .subscribe((payload) => {
        // ✅ ignorar si es exactamente el mismo payload que ya procesamos
        const currentHash = JSON.stringify(payload);
        if (currentHash === lastPayloadHash) {
          console.log('Payload duplicado ignorado');
          return;
        }
        lastPayloadHash = currentHash;

        console.log('=== FormContextProvider recibió payload:', JSON.stringify(payload));
        activeRequestId.current += 1;
        const thisRequestId = activeRequestId.current;

        LoaderService.requestLoader();
        props.getFormInfo(payload)
          .then((formInfo) => {
            if (thisRequestId !== activeRequestId.current) return;
            setFormInfo(formInfo);
          })
          .catch((error) => {
            if (thisRequestId !== activeRequestId.current) return;
            console.error('Error en getFormInfo:', error);
          })
          .finally(() => {
            //if (thisRequestId === activeRequestId.current) {
              LoaderService.closeLoaderRequest();
            //}
          });
      });

    return () => payloadSubscription.unsubscribe();
  }, []);

  useEffect(() => {
    if (props.payload) {
      setValues(props.payload);
    }
  }, [props.payload]);

  const setValidationStyleOn = () => setValidation(true);

  const setFormValues = useCallback((key, value, valid) => {
    setValues(prev => ({ ...prev, [key]: { value, valid } }));
  }, []);

  const removeFormValue = useCallback((name) => {
    setValues(formValues => {
      delete formValues[name];
      return { ...formValues };
    });
  }, []);

  const clearSavedState = useCallback(() => {}, []); // ya no hace nada, se mantiene por compatibilidad

  return (
    <FormContext.Provider value={{
      validated,
      setValidationStyleOn,
      formValues,
      setFormValues,
      apiFormInfo,
      removeFormValue,
      clearSavedState
    }}>
      {props.children}
    </FormContext.Provider>
  );
};

export const FormContextConsumer = FormContext.Consumer;